import { Box, Flex, Stack, Text, Image, Grid } from "@chakra-ui/react";
import AppointButton from "../components/custom/AppointButton";
import { SimpleOutlineButton } from "../components/custom/Button";
import Steps from "../components/custom/Steps";
import RichText from "../components/custom/RichText";
import TestimonialSwiper from "../components/custom/TestimonialSwiper";
import CustomCard from "../components/custom/CustomCard";
import { useColorModeValue } from "../components/ui/color-mode";
import { Helmet } from "react-helmet-async";

const GSTFilingScreen = () => {
  const secondBg = useColorModeValue("#b8fff7", "#090110");
  const cardBg = useColorModeValue("#b8fff7", "#1a1625");

  const steps = [
    {
      label: "Register for GST with our help.",
      icon: "../assets/gst/register.png",
    },
    {
      label: "Share your invoices and transaction data.",
      icon: "../assets/gst/transaction.png",
    },
    {
      label: "Our experts calculate your taxes and file returns.",
      icon: "../assets/gst/tax.png",
    },
    {
      label: "Get a confirmation receipt for your filing.",
      icon: "../assets/gst/receipt.png",
    },
  ];

  const features = [
    {
      src: "../assets/gst/accuracy.png",
      title: "100% Accuracy Guaranteed",
      description:
        "We ensure error-free GST return filing with accurate tax calculations, minimizing compliance risks and penalties.",
    },
    {
      src: "../assets/gst/ontime.png",
      title: "On-Time GST Filings",
      description:
        "Never miss a deadline! Our experts handle your GST filings promptly to avoid late fees and ensure hassle-free compliance.",
    },
    {
      src: "../assets/gst/expert.png",
      title: "Expert CA Assistance",
      description:
        "Get end-to-end support from experienced CAs who help you navigate complex GST laws and compliance requirements.",
    },
    {
      src: "../assets/gst/benefits.png",
      title: "Maximize GST Benefits",
      description:
        "We help you claim input tax credits effectively, reducing your overall tax liability and increasing business savings.",
    },
  ];

  return (
    <>
      {/* Helmet */}
      <Helmet>
        <title>GST Filing Services - 360fintax</title>
        <meta
          name="description"
          content="Simplify your GST filing with 360fintax. Our experts ensure accurate and timely GST returns, helping your business stay compliant effortlessly."
        />
        <link
          rel="canonical"
          href="https://tax-services-web.vercel.app/gst-filing"
        />
      </Helmet>

      {/* Hero Section */}
      <Stack
        bgColor={secondBg}
        py="10"
        px={{ base: "5", md: "10", lg: "20" }}
        alignItems="center"
      >
        <Flex
          alignItems="center"
          gap={{ base: "10", md: "5", lg: "32" }}
          py="10"
          direction={{ base: "column", md: "row" }}
        >
          <Stack
            gap={5}
            justifyContent="start"
            alignItems={{ base: "center", md: "start" }}
            textAlign={{ base: "center", md: "left" }}
            w={{ base: "xs", md: "3xl" }}
          >
            <Text
              fontSize="xl"
              color="#008080"
              letterSpacing="widest"
              fontWeight="semibold"
            >
              Simplify Your GST Filing!
            </Text>
            <Text
              fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
              fontWeight="semibold"
            >
              File your GST returns quickly and accurately with us.{" "}
            </Text>

            <Flex>
              <AppointButton
                text={<SimpleOutlineButton title="Get Started" />}
              />
            </Flex>
          </Stack>
          <Image
            src="../assets/gst/gsthero.png"
            h={{ base: "300px", md: "300px", lg: "350px" }}
            w={{ base: "300px", md: "300px", lg: "350px" }}
            loading="eager"
          />
        </Flex>
      </Stack>

      {/* Steps */}
      <Box py="10" px={{ base: "5", md: "5", lg: "20" }}>
        <Steps
          title="How GST Filing Works"
          colorText=" GST Filing"
          buttonText="File Now"
          steps={steps}
        />
      </Box>

      {/* WHY CHOOSE US */}
      <Stack alignItems="center" gap={10} py={10} data-aos="fade-up">
        <RichText
          title="Why Choose Us for GST Filing?"
          colorText="GST Filing"
        />
        <Grid
          templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
          px={{ base: "5", md: "10", lg: "10" }}
          gap={{ base: "10", md: "10", lg: "10" }}
          justifyItems="center"
        >
          {features.map(({ src, title, description }) => (
            <CustomCard
              data-aos="zoom-in"
              bgColor={cardBg}
              boxShadow="rgba(0, 0, 0, 0.2) 0px 5px 10px"
              title={title}
              description={description}
              src={src}
            />
          ))}
        </Grid>
      </Stack>

      {/* Testmonials */}
      <Stack
        data-aos="fade-up"
        textAlign="center"
        gap="10"
        py={{ base: "10", md: "10", lg: "10" }}
        alignItems="center"
      >
        <RichText
          title="Trusted by Clients,Proven Results"
          colorText="Proven Results"
          description="Discover how we've helped individuals and businesses stay compliant and stress-free, year after year."
          w={{ base: "xs", md: "3xl" }}
        />

        <TestimonialSwiper />
      </Stack>
    </>
  );
};

export default GSTFilingScreen;
